//#region src/generated/locales/be.ts
var templates = {
	"pd.contactus.address.email": `E-mail`,
	"pd.contactus.address.message": `Boodschap`,
	"pd.contactus.address.name": `Naam`,
	"pd.contactus.address.phone": `Telefoon`,
	"pd.contactus.address.send": `Verzenden`,
	"pd.login.email.label": `E-mail`,
	"pd.login.forgot.back": `Terug naar aanmelden`,
	"pd.login.forgot.info": `Voer uw e-mailadres in. U ontvangt een link om uw wachtwoord opnieuw in te stellen.`,
	"pd.login.forgot.password": `Wachtwoord vergeten?`,
	"pd.login.forgot.submit": `Link aanvragen`,
	"pd.login.password.label": `Wachtwoord`,
	"pd.login.submit": `Aanmelden`,
	"pdPage.toast.ariaClose": `Sluiten`,
	"pd.footer.nav.aria": `Footer Navigation`,
	"pd.footer.social.aria": `Social Media`,
	"pd.footer.legal.aria": `Legal Navigation`,
	"pd.menu.nav.aria": `Hauptnavigation`,
	"pd.menu.locale.aria": `Sprache auswählen`,
	"pd.menu.burger.aria": `Menü öffnen`
};
//#endregion
export { templates };
